import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CountryModel } from 'src/app/models/management/country.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private _httpClient: HttpClient) { }

  getAllCountry(): Observable<Array<CountryModel>> {
    return this._httpClient.get<Array<CountryModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.GetAllCountries}`);
  }

  getCountryById(countryId: number): Observable<CountryModel> {
    return this._httpClient.get<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.GetCountryById}/${countryId}`);
  }

  createCountry(countryModel: CountryModel): Observable<CountryModel> {
    return this._httpClient.post<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.CreateCountry}`,
      countryModel);
  }

  updateCountry(countryModel: CountryModel): Observable<CountryModel> {
    return this._httpClient.put<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.UpdateCountry}`,
      countryModel);
  }

  deleteCountry(countryId: number): Observable<CountryModel> {
    return this._httpClient.delete<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.DeleteCountry}/${countryId}`);
  }

  getCountryByCode(code: string): Observable<CountryModel> {
    const params = new HttpParams()
      .set('code', code || '')
    return this._httpClient.get<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.GetCountryByCode}`, { params: params });
  }

  getCountryByUserAuthenticated(): Observable<CountryModel> {
    return this._httpClient.get<CountryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.GetCountryByUserAuthenticatedAsync}`);
  }

  getAllCountriesForSelect(): Observable<CustomListDropdown[]> {
    return this._httpClient.get<CustomListDropdown[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.country.GetAllCountriesForSelectAsync}`,);
  }

}
